<template>
	<v-app>
		<loading-plug v-if="isLoading"></loading-plug>
		<navigation-panel
			:drawer="drawer"
			:login="login"
			:menu="menu"
			:changePage="changePage"
			:changeShowNavigation="changeShowNavigation"
		></navigation-panel>
		<v-app-bar app v-if="login">
			<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
			<img :src="require('@/assets/logo.svg')" height="25" alt="logo"/>
			<h2 class="line font-weight-light" v-if="showProjectName">|</h2>
			<h2 class="headline font-weight-light project" v-if="showProjectName">{{projectName}}</h2>
			<v-spacer></v-spacer>
			<v-menu
				close-on-click
				close-on-content-click
				offset-y
			>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" text>{{login}}</v-btn>
				</template>
				<v-list>
					<v-list-item
						v-for="(item, index) in loginMenu"
						:key="index"
						@click="item.action"
					>
						<v-list-item-title>{{ item.label }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
		<v-content>
			<v-layout
				text-center
				wrap
			>
				<v-flex xs12>
					<router-view
						:toggleLoading="toggleLoading"
						:projects="projects"
						:getProjects="getProjects"
						:inputRoute="inputRoute"
						:authorize="authorize"
						:showMessage="showMessage"
						:changePage="changePage"
						:currentLogin="login"
						:getUserName="getUserName"
						:users="users"
						:getAllUsers="getAllUsers"
						:isNotSaved="isNotSaved"
						:changeIsNotSaved="changeIsNotSaved"
						:changeConfirmFunction="changeConfirmFunction"
						:changeProjectName="changeProjectName"
					>
					</router-view>
				</v-flex>
			</v-layout>
		</v-content>
		<message-component v-bind="message" :cleanMessage="cleanMessage"></message-component>
	</v-app>
</template>

<script>
  import LoadingPlug from "./components/LoadingPlug";
  import MessageComponent from "./components/MessageComponent";
  import NavigationPanel from "./components/NavigationPanel";
  import asyncQuery from "./asyncQuery";

  const initMenuItems = [
    {
      'icon': 'mdi-home',
      'label': 'Главная страница',
      'route': {name: 'MainPage'},
    },
  ];

  const adminMenu = [
    'divider',
    'Администрирование',
    {
      'icon': 'mdi-key',
      'label': 'Проекты',
      'route': {name: 'AdminProjectPage'},
    },
    {
      'icon': 'mdi-account',
      'label': 'Пользователи',
      'route': {name: 'AdminUserPage'},
    },
  ];
  export default {
    name: 'App',
    components: {
      LoadingPlug,
      MessageComponent,
      NavigationPanel,
    },
    data: function () {
      return {
        drawer: false,
        isLoading: false,
        projects: [],
        menu: initMenuItems,
        inputRoute: null,
        login: null,
        loginMenu: [
          {'label': 'Выход', 'action': this.logout}
        ],
        message: {
          text: null,
          color: null,
        },
        isAdmin: false,
        users: [],
        isNotSaved: false,
        projectName: null,
        confirmFunction: () => confirm('Продолжить действие?')
      }
    },
    computed: {
      showProjectName() {
        return ['ProjectPage', 'ProjectPageConcept'].includes(this.$route.name)
      },
    },
    mounted: function () {
      this.getUserName();
    },
    methods: {
      getProjects: function () {
        asyncQuery.bind(this)({
          url: '/api/get_projects',
          handleSuccess: json => {
            this.$data.projects = json;
            this.$data.menu = [...initMenuItems];
            if (this.isAdmin) this.$data.menu.push(...adminMenu);
            this.$data.menu.push('divider', 'Дотсупные проект');
            for (const project of this.projects) {
              this.$data.menu.push({
                'icon': 'mdi-table',
                'label': `${project.label} (${project.project})`,
                'route': {name: 'ProjectPage', params: {name: project.project}},
              })
            }
          },
        })
      },
      toggleLoading: function () {
        this.$data.isLoading = !this.isLoading;
      },
      cleanMessage: function () {
        this.$data.message = {
          show: false,
          text: null,
          color: null,
        }
      },
      getUserName: function () {
        asyncQuery.bind(this)({
          url: '/auth/status',
          handleSuccess: json => {
            this.$data.login = json.data.login;
            this.$data.isAdmin = json.data.isAdmin;
            this.getProjects();
          },
        })
      },
      getAllUsers: function () {
        asyncQuery.bind(this)({
          url: '/api/get_all_users',
          handleSuccess: json => this.$data.users = json,
        })
      },
      authorize: function (login, password) {
        asyncQuery.bind(this)({
          url: '/auth/login',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            login: login,
            password: password,
          }),
          handleSuccess: json => {
            if (json) {
              json['auth_token']
                ? document.cookie = `token=${json['auth_token']}`
                : null;
              this.$data.login = json.login;
              this.$data.isAdmin = json.isAdmin;
              this.changePage(this.inputRoute && this.inputRoute !== '/auth' ? this.inputRoute : {name: 'MainPage'});
              this.getProjects();
            }
          },
          handleStatus: {
            200: () => {
              this.showMessage(`Добрый день, ${login}!`, 'success');
            },
            404: () => {
              this.showMessage('Неверный логин и/или пароль.', 'error');
            }
          }
        })
      },
      logout: function () {
        if (this.isNotSaved) {
          this.confirmFunction();
          return
        }
        document.cookie = 'token=; max-age=0';
        this.$data.login = null;
        this.changePage({name: 'AuthPage'});
      },
      showMessage: function (text, color = null) {
        this.$data.message = {
          show: true,
          text: text,
          color: color,
        };
      },
      changePage: function (next) {
        if (this.isNotSaved) {
          this.confirmFunction(next);
          return
        }
        const prev = this.$router.history.current;
        if (prev.name === next.name) {
          for (const p of Object.keys(prev.params)) {
            if (prev.params[p] !== next.params[p]) this.$router.push(next);
          }
        } else {
          this.$router.push(next);
        }
      },
      changeIsNotSaved: function (val) {
        this.$data.isNotSaved = val;
      },
      changeShowNavigation: function (val) {
        this.$data.drawer = val;
      },
      changeProjectName: function (val) {
        this.$data.projectName = val;
      },
      changeConfirmFunction: function (func) {
        this.$data.confirmFunction = func;
      },
    },
  };
</script>

<style scoped>
	.logo {
		display: flex;
	}
	
	.line {
		font-size: 30px;
		padding-left: 12px;
	}
	
	.project {
		padding-left: 12px;
	}
</style>